export const pricingTargetsFields = [
  {
    name: "countries_section",
    label: "Countries",
    open: true,
    fields: [
      {
        name: "countries",
        label: "Countries",
        type: "countries-table",
        columns: [],
      },
    ],
  },
  {
    name: "target",
    label: "Target",
    open: true,
    fields: [
      {
        name: "gender",
        label: "Gender",
        type: "custom-check",
        description: "Men or women.",
        options: [
          { value: "men", label: "Men" },
          { value: "women", label: "Women" },
        ],
      },
      {
        name: "age",
        label: "Age",
        type: "multi-input",
        layout: "row",
        description: "Age range.",
        fields: [
          {
            name: "age_min",
            label: "Minimum",
            type: "number",
            placeholder: "Minimum",
            min: 15,
            max: 75,
          },
          {
            name: "age_max",
            label: "Maximum",
            type: "number",
            placeholder: "Maximum",
            min: 15,
            max: 75,
          },
        ],
      },
      {
        name: "geo",
        label: "Geo",
        type: "custom-radio",
        description: "What type of geographic distribution.",
        options: [
          { value: "national", label: "National" },
          { value: "local", label: "Local" },
        ],
      },
      {
        name: "target_type_section",
        label: "Target Type",
        type: "multi-input",
        description: "Business to business or business to consumer.",
        fields: [
          {
            name: "target_type",
            label: "Target Type",
            type: "custom-radio",
            options: [
              { value: "b2b", label: "B2B" },
              { value: "b2c", label: "B2C" },
            ],
          },
          {
            name: "industry",
            label: "Industry",
            type: "select",
            placeholder: "Choose a type",
            options: [
              {
                value: "brand_consumers",
                label: "Brand consumers",
                conditions: [{ field: "target_type", value: "b2c" }],
              },
              {
                value: "shop_customers",
                label: "Shop customers",
                conditions: [{ field: "target_type", value: "b2c" }],
              },
              { value: "hobbies", label: "Hobbies", conditions: [{ field: "target_type", value: "b2c" }] },
              { value: "parents", label: "Parents", conditions: [{ field: "target_type", value: "b2c" }] },
              {
                value: "other_ir_greater_than_25",
                label: "Other - IR > 25%",
                conditions: [{ field: "target_type", value: "b2c" }],
              },
              {
                value: "other_ir_less_than_25",
                label: "Other - IR < 25%",
                conditions: [{ field: "target_type", value: "b2c" }],
              },
              { value: "hairdressers", label: "Hairdressers", conditions: [{ field: "target_type", value: "b2b" }] },
              { value: "truck_drivers", label: "Truck drivers", conditions: [{ field: "target_type", value: "b2b" }] },
              { value: "craftsmen", label: "Craftsmen", conditions: [{ field: "target_type", value: "b2b" }] },
              {
                value: "restaurant_owners",
                label: "Restaurant owners",
                conditions: [{ field: "target_type", value: "b2b" }],
              },
              { value: "midwives", label: "Midwives", conditions: [{ field: "target_type", value: "b2b" }] },
              { value: "nurses", label: "Nurses", conditions: [{ field: "target_type", value: "b2b" }] },
              {
                value: "life_assistant",
                label: "Life assistant",
                conditions: [{ field: "target_type", value: "b2b" }],
              },
              { value: "other", label: "Other", conditions: [{ field: "target_type", value: "b2b" }] },
            ],
          },
        ],
      },
      {
        name: "incidence_rate",
        label: "Incidence Rate",
        placeholder: "10%",
        type: "number",
        min: 0,
        max: 100,
        description: "The incidence rate of the target (%).",
        condition: (target) => target.target_type === "b2c" && target.industry !== "parents",
        perCountry: true,
        perCountryColumns: [
          { name: "value", label: "Value", type: "number", colSpan: 6, placeholder: "Value" },
          { name: "auto", label: "Auto", type: "readonly", colSpan: 3, align: "center" },
          { name: "manual", label: "Manual", type: "number", colSpan: 3, align: "center" },
        ],
      },
      {
        name: "targeting_quality",
        label: "Targeting Quality",
        type: "custom-radio",
        tooltip:
          "Good = we have identified specific targeting criteria available to reach this population quite precisely",
        description: "How good is the target.",
        hideAuto: true,
        hideManual: true,
        options: [
          { value: "good", label: "Good" },
          { value: "average", label: "Average" },
        ],
        conditions: [
          { field: "target_type", value: "b2c" },
          { field: "industry", value: "other_ir_less_than_25" },
        ],
      },
      {
        name: "children_age",
        label: "Children Age Range",
        type: "custom-radio",
        description: "The children age range",
        options: [
          { value: "pregnant_women", label: "Pregnant women" },
          { value: "0_1_years", label: "0-1 years" },
          { value: "2_4_years", label: "2-4 years" },
          { value: "5_more_years", label: "5+ years" },
        ],
        conditions: [
          { field: "target_type", value: "b2c" },
          { field: "industry", value: "parents" },
        ],
      },
      {
        name: "additional_incidence_ratio",
        label: "Additional Incidence Ratio",
        type: "number",
        min: 0,
        max: 100,
        description: "The additional incidence ratio of the target (%).",
        perCountry: true,
        perCountryColumns: [
          { name: "value", label: "Value", type: "number", colSpan: 6, placeholder: "Value" },
          { name: "auto", label: "Auto", type: "readonly", colSpan: 3, align: "center" },
          { name: "manual", label: "Manual", type: "number", colSpan: 3, align: "center" },
        ],
      },
    ],
  },
  {
    name: "quotas",
    label: "Quotas",
    open: false,
    fields: [
      {
        name: "quota_gender",
        label: "Gender",
        type: "custom-radio",
        tooltip: "Hard = no tolerance, Soft = +/-20% tolerance",
        description: "Quota on the gender.",
        options: [
          { value: "hard", label: "Hard" },
          { value: "soft", label: "Soft" },
          { value: "none", label: "None" },
        ],
        conditions: [
          { field: "gender.men", value: true },
          { field: "gender.women", value: true },
        ],
      },
      {
        name: "quota_age",
        label: "Age",
        type: "custom-radio",
        tooltip: "Hard = no tolerance, Soft = +/-20% tolerance",
        description: "Quota on the age.",
        options: [
          { value: "hard", label: "Hard" },
          { value: "soft", label: "Soft" },
          { value: "none", label: "None" },
        ],
      },
      {
        name: "quota_geo",
        label: "Geo",
        type: "custom-radio",
        tooltip: "Hard = no tolerance, Soft = +/-20% tolerance",
        description: "Quota in the geographic area.",
        options: [
          { value: "hard", label: "Hard" },
          { value: "soft", label: "Soft" },
          { value: "none", label: "None" },
        ],
      },
      {
        name: "quota_other",
        label: "Other quota",
        type: "text",
        hide_auto: true,
        placeholder: "Write a custom quota",
        description: "Add a custom quota.",
      },
    ],
  },
  {
    name: "questionnaire",
    label: "Questionnaire",
    open: false,
    fields: [
      {
        name: "channel",
        label: "Channel",
        type: "custom-radio",
        description: "Type of Channel.",
        options: [
          { value: "episto", label: "Episto" },
          { value: "external", label: "External" },
        ],
      },
      {
        name: "loi",
        label: "LOI",
        type: "custom-radio",
        tooltip: `0-15q -> 3min
                  20q -> 5min
                  30q -> 8min
                  40q -> 10min
                  50q -> 12min
                  60q -> 15min`,
        description: "LOI.",
        options: [
          { value: "0-15q", label: "0-15q" },
          { value: "20q", label: "20q" },
          { value: "30q", label: "30q" },
          { value: "40q", label: "40q" },
          { value: "50q", label: "50q" },
          { value: "60q+", label: "60+q" },
        ],
      },
      {
        name: "content",
        label: "Content",
        type: "multi-input",
        layout: "row",
        description: "Content type and topic.",
        fields: [
          {
            name: "content_type",
            label: "Type",
            type: "select",
            placeholder: "Other",
            options: [
              { value: "pre_test_and_post_test", label: "Pre-test and/or Post-test" },
              { value: "concept_test", label: "Concept test" },
              { value: "ua_consomation_habits", label: "U&A - Consumption patterns" },
              { value: "ua_other", label: "U&A - Other" },
              { value: "opinion_society", label: "Opinion poll/Society" },
              { value: "market_image_notoriety", label: "Market research/brand awareness" },
              { value: "user_satisfaction", label: "Customer satisfaction survey" },
              { value: "other", label: "Other" },
            ],
          },
          {
            name: "content_topic",
            label: "Topic",
            type: "select",
            placeholder: "Other",
            options: [
              { value: "automotive", label: "Automotive" },
              { value: "business", label: "Business" },
              { value: "cosmetic_personal_care", label: "Cosmetics, Personal Care" },
              { value: "family_child_parenting", label: "Family, Child, Parenting" },
              { value: "fashion", label: "Fashion" },
              { value: "finance_banking_insurance", label: "Finance, Banking, Insurance" },
              { value: "food", label: "Food" },
              { value: "government_politics", label: "Government, Politics" },
              { value: "health", label: "Health" },
              { value: "public", label: "Public" },
              { value: "real_estate", label: "Real Estate" },
              { value: "recreation", label: "Recreation (sports, travel, media…)" },
              { value: "shopping_retail_ecommerce", label: "Shopping, Retail, E-commerce" },
              { value: "transportation", label: "Transportation" },
              { value: "other", label: "Other" },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "settings",
    label: "Settings",
    open: false,
    fields: [
      {
        name: "margin",
        label: "Margin",
        description: "Define the margin.",
        type: "none",
      },
      {
        name: "timing",
        label: "Timing",
        type: "custom-radio",
        tooltip:
          "Urgent = less than 7d for data collection, less than 10d if it includes questionnaire design or translation, less than 3 weeks for full service.",
        description: "Timing.",
        options: [
          { value: "standard", label: "Standard" },
          { value: "urgent", label: "Urgent" },
        ],
      },
    ],
  },
];
